

































































































































































































import Vue from "vue";
import { $eventsBus } from "@/main";
import BaseCheckbox from "@/app/shared/components/base/BaseCheckbox.vue";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";
import { Item } from "../../models/classes/Item";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { NamingTemplates } from "../../models/classes/NamingTemplates";

export default Vue.extend({
  name: "DownloadPanel",
  components: {
    BaseCheckbox,
    BaseButton,
    vueCustomScrollbar,
  },
  data: function () {
    return {
      checkedCount: 0,
      renderIdsForCheck: [],
      renderCanceled: false,
      loading: true,
      //percent: -1,
      message: "Upload...",
      yandex: "",
      checkStatusId: null,
      copyingInfo: {
        isCopyingNow: false,
        text: "",
        link: null,
      },
      showLoader: false,
    };
  },
  created() {
    $eventsBus.$on("exportItems", () => {
      //this.buyingStockMaterialsAndStartRender();
      this.sendToRender();
    });
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    percentNew: function () {
      return Math.floor(
        (this.renderItems.reduce((acc, item) => {
          if (item.loaded || item.error) {
            return acc + 1;
          } else {
            return acc + item.done / 100;
          }
        }, 0) /
          this.renderItems.length) *
          100
      );
    },
    renderItems: {
      // getter
      get: function () {
        return this.$store.state.renderItems;
      },
      // setter
      set: function (newValue) {
        this.$store.commit("renderItems", newValue);
      },
    },
    isSomeChecked: function () {
      return this.renderItems.length === 0
        ? false
        : !this.renderItems.every((i) => i.checked) &&
            this.renderItems.some((i) => i.checked);
    },
    isAllChecked: {
      // getter
      get: function () {
        return this.renderItems.length === 0
          ? false
          : this.renderItems.every((i) => i.checked);
      },
      // setter
      set: function (newValue) {
        if (newValue) {
          this.renderItems.forEach((item) => {
            item.checked = true;
          });
        } else {
          this.renderItems.forEach((item) => {
            item.checked = false;
          });
        }
      },
    },
    hasUATasks: function () {
      return this.renderItems.length === 0
        ? false
        : this.renderItems.some((i) => i.fromUA);
    },
    isSomeCheckedAndLoaded: function () {
      let chckedItems = this.renderItems.filter((i) => i.checked);
      return chckedItems.length === 0
        ? false
        : chckedItems.some((i) => i.loaded && !i.error);
    },
    isSomeCheckedLoadedAndAllFromUA: function () {
      let chckedItems = this.renderItems.filter((i) => i.checked);
      return chckedItems.length === 0
        ? false
        : chckedItems.every((i) => i.fromUA && i.loaded && !i.error);
    },
    hasLoadedItems: function () {
      return this.renderItems.some((i) => i.loaded);
    },
    isInHouse: function () {
      return this.$store.state.userInfo.isInHouse;
    },
  },
  watch: {
    renderItems: {
      deep: true,
      handler() {
        if (this.renderItems.length === 0) {
          this.$store.commit("showDownloadPanel", false);
          this.stopUpdating();
        } else {
          this.renderIdsForCheck = this.renderItems
            .filter((i) => !i.loaded)
            .map((i) => i.renderId);
          if (this.checkStatusId === null && this.renderIdsForCheck.length) {
            this.checkStatusId = setInterval(this.checkMultiStatus, 1000);
          }
        }
        this.checkedCount = this.renderItems.filter((v) => v.checked).length;
      },
    },
  },
  methods: {
    onClearDone() {
      this.renderItems = this.renderItems.filter((i) => {
        if (i.loaded) {
          this.renderIdsForCheck.splice(
            this.renderIdsForCheck.indexOf(i.renderId),
            1
          );
        }
        return !i.loaded;
      });
      $eventsBus.$emit("saveUserWorkspace", true);
    },
    onMultiDelete() {
      this.renderItems.forEach((i) => {
        this.renderCancel(i.renderId)
      });

      if (this.isAllChecked) {
        this.renderItems = [];
        this.stopUpdating();
        $eventsBus.$emit("saveUserWorkspace", true);
        return;
      }

      this.renderItems
        .map((it) => it)
        .forEach((i) => {
          if (i.checked) {
            this.renderItems.splice(this.renderItems.indexOf(i), 1);
            this.renderIdsForCheck.splice(
              this.renderIdsForCheck.indexOf(i.renderId),
              1
            );
          }
        });

      if (this.renderIdsForCheck.length === 0) {
        this.stopUpdating();
      }
      $eventsBus.$emit("saveUserWorkspace", true);
    },
    onCopyFileName() {
      if (this.isSomeChecked || this.isAllChecked) {
        this.copyingInfo.isCopyingNow = true;
        this.copyingInfo.text = "Wait...";

        const fileExtension = ".mp4";
        let copiedText = "";

        this.renderItems.forEach((i) => {
          if (i.checked) {
            copiedText += `${i.fileName}${fileExtension}\n`;
          }
        });

        navigator.clipboard
          .writeText(copiedText)
          .then(() => {
            this.copyingInfo.text = "Copied!";
            console.log("Successfully copied");
          })
          .catch((err) => {
            this.copyingInfo.text = "Uncopied!";
            console.log("Something went wrong", err);
          })
          .finally(() => {
            setTimeout(() => {
              this.copyingInfo.isCopyingNow = false;
            }, 1000);
          });
      }
    },
    onStopRender() {
      this.renderItems.forEach((i) => {
        console.log("Удаляем: "+i.renderId);
        this.renderCancel(i.renderId);
      });

      this.renderItems = this.renderItems.filter((i) => i.loaded);
      this.stopUpdating();
    },
    stopUpdating() {
      this.loading = false;
      //this.percent = -1;
      this.message = "Upload...";
      clearInterval(this.checkStatusId);
      this.checkStatusId = null;
      this.renderIdsForCheck = [];
    },
    onCheckItem(item) {
      this.$forceUpdate();
    },
    onClickItemIcon(item, onlyPreview?) {
      if (item.loaded && !item.error) {
        //watch
        $eventsBus.$emit("showRenderItemPreview", item);
        this.$store.commit("showRendersPreviewWindow", true);
      } else {
        //delete - cancelRender

        if (onlyPreview) {
          this.renderCancel(item.renderId);
          return;
        }
        this.renderIdsForCheck.splice(
          this.renderIdsForCheck.indexOf(item.renderId),
          1
        );
        this.renderItems.splice(this.renderItems.indexOf(item), 1);
        if (this.renderIdsForCheck.length === 0) {
          this.stopUpdating();
        }
        $eventsBus.$emit("saveUserWorkspace", true);
      }
    },
    renderCancel(id){
      this.axios
          .post(
              "/utils/cancelDownload",
              {
                sessionId: this.$store.state.userInfo.sessionId,
                renderId: id,
              },
              {
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              }
          )
          .catch((erorr) => {
            console.error(erorr);
          });
    },
    onClickDownload() {
      if (!this.isSomeCheckedAndLoaded) {
        return;
      }

      if (!this.showLoader) {
        this.downloadResult();
      } else {
        console.warn('Обработка данных, повторите попытку позже')
      }

      let countToDownload = this.renderItems.filter(
        (i) => i.checked && i.loaded && !i.error
      ).length;

      //TODO test yandex metrik
      try {
        if (this.$metrika) {
          this.$metrika.reachGoal("download", {
            "Клик на download": countToDownload,
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    onClickUploadAssets() {
      if (!this.isSomeCheckedLoadedAndAllFromUA) {
        return;
      }
      let uploadingItems = this.renderItems
        .filter((i) => i.checked && i.loaded && !i.error && i.fromUA)
        .map((i) => i.renderId);
      this.axios
        .post(
          "/utils/getHash",
          {
            sessionId: this.$store.state.userInfo.sessionId,
            renderIds: uploadingItems,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          let uaBaseURL =
            this.$buildType === "production"
              ? `https://ua1.roasup.com`
              : `https://dev3.roasup.com`;
          window.open(
            uaBaseURL +
              `/#creatives/assets?creativeStudioTaskId=` +
              res.data.hash
          );
        })
        .catch((erorr) => {
          console.error(erorr);
        });
    },
    createTitleFilter(name) {
      switch (name) {
        case "Black & White":
          return "bw";
        case "Brightness":
          return "brightness";
        case "Saturation":
          return "saturation";
        case "Invert":
          return "invert";
        case "Contrast":
          return "contrast";
        case "Sepia":
          return "sepia";
        case "Glitch":
          return "glitch";
        default:
          return "origin";
      }
    },
    calcUnsharp(userOuterVideoResolutionsDifference, isSharpEnabled) {
      if (!isSharpEnabled) {
        return null;
      }

      const MIN_UNSHARP = 0;
      const MAX_UNSHARP = 3.5;

      const unsharp =
        Math.round((userOuterVideoResolutionsDifference - 1) * 100) / 100;

      if (unsharp <= MIN_UNSHARP) {
        return 0;
      } else if (unsharp > MAX_UNSHARP) {
        return MAX_UNSHARP;
      } else {
        return unsharp;
      }
    },
    async sendToRender() {
      let filteredVariations = this.items
        .reduce((acc, val) => acc.concat(val.variations), [])
        .filter((v) => v.checked); //render only checked
      //let tasks = await
      let p = new Promise((resolve) => {
        let tasks = Promise.all(
          filteredVariations.map(async (itemVariation) => {
            let videoPreviewPixelsWidth =
              this.$store.getters.videoPreviewPixelsWidth;
            let backgroungImageWH = itemVariation.getBackgroungImageWH();
            let effectReq = "";
            if (itemVariation.parentItem.isOutsize) {
              effectReq =
                itemVariation.currentSize.title === "Original"
                  ? "original"
                  : itemVariation.preset.name;
            } else {
              effectReq =
                itemVariation.currentSize.name !==
                  itemVariation.parentItem.inputSize.name ||
                itemVariation.parentItem.isForSlice
                  ? itemVariation.preset.name
                  : "original";
            }
            let userOuterVideoResolutionsDifference =
              itemVariation.parentItem.isOutsize &&
              itemVariation.currentSize.title === "Original"
                ? 1
                : itemVariation.previewParameters
                    .userOuterVideoResolutionsDifference;
            let pixelScale =
              Math.round(
                itemVariation.previewParameters.outerVideoResolutionX *
                  userOuterVideoResolutionsDifference
              ) +
              "x" +
              Math.round(
                itemVariation.previewParameters.outerVideoResolutionY *
                  userOuterVideoResolutionsDifference
              );
            let fullFilter = itemVariation.getFullFilter();
            let filterToSend = {
              gamma: fullFilter.brightness,
              contrast: fullFilter.contrast,
              saturation: fullFilter.saturation,
              tint: fullFilter.tint,
              invert: fullFilter.invert,
              sepia: fullFilter.sepia,
              glitch: fullFilter.glitch,
              sharpen: fullFilter.sharpen,
              title: this.createTitleFilter(itemVariation.filter.currentPreset),
            };
            let sortedAndFilteredOverlays = itemVariation.overlays
              .map((o) => o)
              .reverse()
              .filter((o) => {
                let time =
                  itemVariation.getMoveableOverlayObjectTimeBasedOnCurrentDuration(
                    o
                  );
                return (
                  (time.startTime !== -1 && time.finishTime !== -1) ||
                  o.alpha === 0
                );
              });
            let sortedAndFilteredOverlaysOfBackside =
              itemVariation.overlaysOfBackside
                .map((o) => o)
                .reverse()
                .filter((o) => {
                  let time =
                    itemVariation.getMoveableOverlayObjectTimeBasedOnCurrentDuration(
                      o
                    );
                  return (
                    (time.startTime !== -1 && time.finishTime !== -1) ||
                    o.alpha === 0
                  );
                });
            let overlays:any = await Promise.all(
              sortedAndFilteredOverlays
                .concat(sortedAndFilteredOverlaysOfBackside)
                .map(async (o) => {
                  let overlayIndex =
                    sortedAndFilteredOverlays.indexOf(o) !== -1
                      ? sortedAndFilteredOverlays.indexOf(o) + 1
                      : -sortedAndFilteredOverlaysOfBackside.indexOf(o) - 1;
                  if (
                    o.type === "image" ||
                    o.type === "video" ||
                    o.type === "stock" ||
                    o.type === "stock-video" ||
                    o.type === "emojipedia" ||
                    o.type === "animation"
                  ) {
                    let stickerXYWH = o.getOverlayXYWH(
                      videoPreviewPixelsWidth,
                      itemVariation.previewParameters.outerVideoResolutionX,
                      userOuterVideoResolutionsDifference,
                      itemVariation.currentSize
                    );
                    let stickerTime =
                      itemVariation.getMoveableOverlayObjectTimeBasedOnCurrentDuration(
                        o
                      );

                    return {
                      id:
                        o.type !== "stock" && o.file
                          ? o.file.id
                          : o.file.systemMethod === "pixabay"
                          ? o.file.id
                          : -1,
                      json: o.type.startsWith("animation")
                        ? JSON.stringify(o.file.json)
                        : null,
                      fps: o.type.startsWith("animation")
                        ? o.getAnimationPropAtPath(o.file.json, o.file.fps.path)
                        : null,
                      index: overlayIndex,
                      alpha: o.alpha,
                      X: stickerXYWH ? stickerXYWH.x : null,
                      Y: stickerXYWH ? stickerXYWH.y : null,
                      Xlt: stickerXYWH
                        ? stickerXYWH.x - stickerXYWH.w / 2
                        : null,
                      Ylt: stickerXYWH
                        ? stickerXYWH.y - stickerXYWH.h / 2
                        : null,
                      W: stickerXYWH ? stickerXYWH.w : 200,
                      H: stickerXYWH ? stickerXYWH.h : 200,
                      rotate: o.transforms.rotate,
                      start:
                        Math.round(
                          Math.round((
                            o.isCustomTime
                            ? stickerTime.startTime
                            : itemVariation.cut.startTime) * 1000) -
                          Math.round(itemVariation.cut.startTime * 1000)
                        ),
                        // / itemVariation.speed,
                      end:
                        Math.round(
                          Math.round((
                            o.isCustomTime
                            ? stickerTime.finishTime
                            : itemVariation.cut.finishTime) * 1000) -
                          Math.round(itemVariation.cut.startTime * 1000)
                        ),
                        // / itemVariation.speed,
                      animation: {
                        in: {
                          type: o.animation.fadeIn.type,
                          duration: Math.round(o.animation.fadeIn.time * 1000),
                        },
                        out: {
                          type: o.animation.fadeOut.type,
                          duration: Math.round(o.animation.fadeOut.time * 1000),
                        },
                      },
                      stock:
                        o.type === "stock" &&
                        o.file &&
                        o.file.systemMethod !== "pixabay"
                          ? o.file
                          : null,
                      systemMethod: o.file
                        ? o.type === "stock" &&
                          o.file.systemMethod !== "pixabay"
                          ? "multistickers"
                          : o.file.systemMethod.startsWith("animation")
                          ? "lottie"
                          : o.file.systemMethod
                        : null,
                      backgroundColor: null,
                      customUserText: o.type.startsWith("animation")
                        ? o.getAllTextFields()[0]?.value //TODO пока берем только первый текстовый элемент
                        : undefined,
                    };
                  } else if (o.type === "text") {
                    let textImage = o.getTextImage(
                      videoPreviewPixelsWidth,
                      itemVariation.previewParameters.outerVideoResolutionX,
                      userOuterVideoResolutionsDifference,
                      itemVariation.currentSize
                    );
                    let textTime =
                      itemVariation.getMoveableOverlayObjectTimeBasedOnCurrentDuration(
                        o
                      );
                    return {
                      index: overlayIndex,
                      image:
                        o.value !== "" &&
                        textTime.startTime !== -1 &&
                        textTime.finishTime !== -1
                          ? textImage.image
                          : null,
                      X: textImage.x,
                      Y: textImage.y,
                      W: textImage.w,
                      H: textImage.h,
                      rotate: o.transforms.rotate,
                      alpha: 1, //itemVariation.text.style.opacity,
                      start:
                        Math.round(
                          Math.round((
                            o.isCustomTime
                            ? textTime.startTime
                            : itemVariation.cut.startTime) * 1000) -
                          Math.round(itemVariation.cut.startTime * 1000)
                        ),
                        // / itemVariation.speed,
                      end:
                        Math.round(
                          Math.round((
                            o.isCustomTime
                            ? textTime.finishTime
                            : itemVariation.cut.finishTime) * 1000) -
                          Math.round(itemVariation.cut.startTime * 1000)
                        ),
                        // / itemVariation.speed,
                      animation: {
                        in: {
                          type: o.animation.fadeIn.type,
                          duration: Math.round(o.animation.fadeIn.time * 1000),
                        },
                        out: {
                          type: o.animation.fadeOut.type,
                          duration: Math.round(o.animation.fadeOut.time * 1000),
                        },
                      },
                      systemMethod: "text",
                      backgroundColor: null,
                      customUserText: o.value,
                    };
                  } else {
                    let shapeImage = await o.getShapeImage(
                      videoPreviewPixelsWidth,
                      itemVariation.previewParameters.outerVideoResolutionX,
                      userOuterVideoResolutionsDifference,
                      itemVariation.currentSize,
                      this.$baseURL
                    );
                    let shapeTime =
                      itemVariation.getMoveableOverlayObjectTimeBasedOnCurrentDuration(
                        o
                      );
                    return {
                      index: overlayIndex,
                      image:
                        o.value !== "" &&
                        shapeTime.startTime !== -1 &&
                        shapeTime.finishTime !== -1
                          ? shapeImage.image
                          : null,
                      X: shapeImage.x,
                      Y: shapeImage.y,
                      W: shapeImage.w,
                      H: shapeImage.h,
                      rotate: o.transforms.rotate,
                      alpha: 1, //itemVariation.text.style.opacity,
                      start:
                        Math.round(
                          Math.round((
                            o.isCustomTime
                            ? shapeTime.startTime
                            : itemVariation.cut.startTime) * 1000) -
                          Math.round(itemVariation.cut.startTime * 1000)
                        ),
                        // / itemVariation.speed,
                      end:
                        Math.round(
                          Math.round((
                            o.isCustomTime
                            ? shapeTime.finishTime
                            : itemVariation.cut.finishTime) * 1000) -
                          Math.round(itemVariation.cut.startTime * 1000)
                        ),
                        // / itemVariation.speed,
                      animation: {
                        in: {
                          type: o.animation.fadeIn.type,
                          duration: Math.round(o.animation.fadeIn.time * 1000),
                        },
                        out: {
                          type: o.animation.fadeOut.type,
                          duration: Math.round(o.animation.fadeOut.time * 1000),
                        },
                      },
                      systemMethod: "shape",
                      backgroundColor: o.style.color,
                    };
                  }
                })
            );
            overlays.forEach((overlay, index) => {
              if (overlay.image === 'data:,') {
                console.warn(
                  `(-) Ошибка извлечения данных из оверлея ${overlay?.customUserText}\n`,
                  overlay,
                  `\nУдаляю оверлей из задачи на рендер\n`,
                  `Пожалуйста, свяжитесь с фиксиками\n`
                )
                overlays.splice(index, 1)
              }
            })
            let variationParentItem = this.items.find(
              (item) => item.id === itemVariation.parentItem.id
            );
            let variationName = NamingTemplates.getVariationOutputFileName(
              itemVariation,
              this.items.indexOf(variationParentItem) + 1,
              this.items
                .reduce((acc, val) => acc.concat(val.variations), [])
                .indexOf(itemVariation) + 1,
              this.isInHouse
            )
            let shadow = itemVariation.shadow.visible ? itemVariation.shadow : null
            return {
              fileId: itemVariation.parentItem.fileId,
              name: itemVariation.parentItem.name,
              effectReq: effectReq,
              color:
                itemVariation.currentSize.name !==
                  itemVariation.parentItem.inputSize.name &&
                itemVariation.preset.name === "color"
                  ? itemVariation.backgroundColor.replace("#", "")
                  : null,
              //filter: itemVariation.filter.serverName,
              filterParam: {
                ...filterToSend,
                unsharp: this.calcUnsharp(
                  userOuterVideoResolutionsDifference,
                  false//itemVariation.isSharpEnabled
                ),
              },
              image:
                itemVariation.currentSize.name !==
                  itemVariation.parentItem.inputSize.name &&
                itemVariation.preset.name === "image"
                  ? itemVariation.backgroundImage.id
                  : null,
              pixelScale: pixelScale,
              videoW: itemVariation.previewParameters.outerVideoResolutionX,
              /* itemVariation.currentSize.name !==
                  itemVariation.parentItem.inputSize.name &&
                itemVariation.preset.name === "image"
                  ? backgroungImageWH.imageW
                  : null,*/
              videoH: itemVariation.previewParameters.outerVideoResolutionY,
              /* itemVariation.currentSize.name !==
                  itemVariation.parentItem.inputSize.name &&
                itemVariation.preset.name === "image"
                  ? backgroungImageWH.imageH
                  : null, */
              /*               imageType:
                itemVariation.currentSize.name !== itemVariation.inputSize.name &&
                itemVariation.preset.name === "image"
                  ? backgroungImageWH.imageType
                  : null, */
              sizeReq:
                itemVariation.parentItem.isOutsize &&
                itemVariation.currentSize.title === "Original"
                  ? itemVariation.parentItem.inputSize.name
                  : itemVariation.currentSize.name,
              x:
                effectReq !== "crop" && effectReq !== "slicer"
                  ? itemVariation.previewParameters.displayHorizontalShift === 0
                    ? null
                    : -itemVariation.previewParameters.horizontalShift +
                      (itemVariation.previewParameters.customHorizontalPadding *
                        itemVariation.previewParameters.zoom) /
                        100
                  : itemVariation.previewParameters.horizontalShift,
              y:
                effectReq !== "crop" && effectReq !== "slicer"
                  ? itemVariation.previewParameters.displayVerticalShift === 0
                    ? null
                    : -itemVariation.previewParameters.verticalShift +
                      (itemVariation.previewParameters.customVerticalPadding *
                        itemVariation.previewParameters.zoom) /
                        100
                  : itemVariation.previewParameters.verticalShift,
              zoom: itemVariation.previewParameters.zoom / 100,
              overlays: overlays,
              audio: {
                audioId: !!itemVariation.music.file
                  ? itemVariation.music.libraryType === "uploaded"
                    ? itemVariation.music.file.id
                    : -1
                  : null,
                audioStart:
                  Math.round(itemVariation.music.file
                  ? itemVariation.music.isCustomTime
                    ? (Math.round(itemVariation.music.startTime * 1000) -
                       Math.round(itemVariation.cut.startTime * 1000))
                      //  / itemVariation.speed
                    : 0
                  : 0),
                audioEnd: 0,
                audioVolume: itemVariation.music.volume,
                audioStock:
                  itemVariation.music.libraryType !== "uploaded"
                    ? itemVariation.music.file
                    : null,
                audioPackshot: itemVariation.music.isExtendToEndCard,
              },
              volume: itemVariation.volume,
              packshot: {
                id:
                  itemVariation.endCard.packshot &&
                  itemVariation.endCard.packshot.list[
                    itemVariation.currentSize.name.toLowerCase()
                  ]
                    ? itemVariation.endCard.getType() === "video"
                      ? itemVariation.endCard.packshot.list[
                          itemVariation.currentSize.name.toLowerCase()
                        ].id
                      : itemVariation.endCard.packshot.packId
                    : null,
                method: itemVariation.endCard.transitionStyleId,
                volume: itemVariation.endCard.volume,
                type:
                  itemVariation.endCard.packshot &&
                  itemVariation.endCard.getType().startsWith("template")
                    ? "lottie"
                    : null,
                fps:
                  itemVariation.endCard.packshot &&
                  itemVariation.endCard.getType().startsWith("template")
                    ? itemVariation.endCard.getFPS()
                    : null,
                duration:
                  itemVariation.endCard.packshot &&
                  itemVariation.endCard.getType().startsWith("template")
                    ? itemVariation.endCard.getDuration()
                    : null,
                json:
                  itemVariation.endCard.packshot &&
                  itemVariation.endCard.getType().startsWith("template")
                    ? JSON.stringify(itemVariation.endCard.packshot.json)
                    : null,
              },
              cuts: {
                frames:
                  itemVariation.cut.startTime === 0 &&
                  itemVariation.cut.finishTime ===
                    itemVariation.parentItem.duration
                    ? null
                    : [
                        Math.floor(
                          itemVariation.cut.startTime *
                            itemVariation.parentItem.fps
                        ),
                        Math.ceil(
                          itemVariation.cut.finishTime *
                            itemVariation.parentItem.fps
                        ),
                      ],
                times:
                  itemVariation.cut.startTime === 0 &&
                  itemVariation.cut.finishTime ===
                    itemVariation.parentItem.duration
                    ? null
                    : [
                        Math.floor(itemVariation.cut.startTime * 1000),
                        Math.ceil(itemVariation.cut.finishTime * 1000),
                      ],
              },
              speed: itemVariation.speed === 1 ? null : itemVariation.speed,
              flip:
                itemVariation.flipVertical && itemVariation.flipHorizontal
                  ? "both"
                  : itemVariation.flipVertical
                  ? "up"
                  : itemVariation.flipHorizontal
                  ? "left"
                  : null,
              metadata: itemVariation.isRemoveMetadata ? 0 : 1,
              quality: {
                bitrate: itemVariation.fileOutputParameters.bitrate,
              },
              fileSizeReq: {
                enable: itemVariation.fileOutputParameters.isStrictMaxSize,
                size: itemVariation.getFileOutputSizeMb() * 1024 * 1024,
              },
              originalName: itemVariation.isSaveOriginalName,
              outputName: variationName,
              language: NamingTemplates.getVariationLanguage(itemVariation),
              itemPosition: this.items.indexOf(variationParentItem) + 1,
              uploadedType: variationParentItem.loadingParameters.uploadedType,
              shadow: shadow,
            };
          })
        );
        resolve(tasks);
      }).then((tasks) => {
        let startMultiRender = {
          tasks: tasks,
          uploadToYandex: this.$store.getters.uploadToCloud,
          sessionId: this.$store.state.userInfo.sessionId,
        };
        this.startMultiRenderVideos(startMultiRender);
        //$eventsBus.$emit("itemsExported");
      });
    },

    //------------------------------------ RESIZER & SLICER
    startMultiRenderVideos(postData) {
      this.message = "Prepare render task ...";
      this.axios
        .post("/video/prepareToRender", postData, {
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (!this.renderCanceled) {
            console.log(response.data);
            this.$store.commit("showDownloadPanel", true);
            this.message = "Progress...";
            if (response.data.success) {
              response.data.tasks.forEach((t) => {
                this.renderItems.unshift({
                  ...t,
                  done: 0,
                  checked: true,
                  loaded: false,
                  error: false,
                  preset: t.type.charAt(0).toUpperCase() + t.type.slice(1),
                  size:
                    t.size.toUpperCase() === "S"
                      ? "1:1"
                      : t.size.toUpperCase() === "F"
                      ? "4:5"
                      : t.size.toUpperCase() === "P"
                      ? "2:3"
                      : t.size.toUpperCase() === "V"
                      ? "9:16"
                      : t.size.toUpperCase() === "H"
                      ? "16:9"
                      : "",
                });
              });
              this.renderIdsForCheck = this.renderItems
                .filter((i) => !i.loaded)
                .map((i) => i.renderId);
              if (this.checkStatusId === null) {
                this.checkStatusId = setInterval(this.checkMultiStatus, 1000);
              }
            } else {
              this.message = "Server error!";
            }
            $eventsBus.$emit("saveUserWorkspace", true);
          }
          $eventsBus.$emit("itemsExported");
        })
        .catch((erorr) => {
          this.message = "Server error!";
          console.error(erorr);
          $eventsBus.$emit("itemsExported");
        });
    },
    checkMultiStatus() {
      let renderIds = this.renderIdsForCheck;

      if (renderIds.length === 0) {
        this.stopUpdating();
      }

      this.axios
        .post(
          "/video/checkMultiStatus",
          {
            renderIds: renderIds,
            sessionId: this.$store.state.userInfo.sessionId,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.successCheckMultiStatus(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    successCheckMultiStatus(data) {
      if (this.renderCanceled) {
        this.stopUpdating();
        return;
      }
      if (data.status.toLowerCase() === "done") {
        this.message = "Render complete";
        //this.percent = 100;
        setTimeout(() => {
          this.stopUpdating();
        }, 500);

        let errorIds = [];
        data.tasks.forEach((task) => {
          let renderItem = this.renderItems.find((i) => i.renderId === task.id);

          if (renderItem && !renderItem.loaded) {
            renderItem.path = task.path;
            renderItem.outputName = task.fileName;
            renderItem.loaded = true;
            renderItem.error = task.task.toLowerCase() === "error";
            if (renderItem.error) {
              errorIds.push(task.id);
            }

            if (renderItem.loaded && !renderItem.error) {
              renderItem.fileSize = task.size;
            }
            renderItem.done = 1;
          }
        });
        if (errorIds.length !== 0) {
          //TODO test yandex metrik
          try {
            if (this.$metrika) {
              this.$metrika.reachGoal("render_error", {
                "Ошибка при рендере видео": {
                  CID: 0,
                  type: "successCheckMultiStatus_data-status-done",
                  renderIds: errorIds,
                },
              });
            }
          } catch (e) {
            console.error(e);
          }
        }
        this.yandex = data.yandex;
        $eventsBus.$emit("saveUserWorkspace", true);
      } else {
        let tasksAllCount = data.tasks.length;
        let tasksDoneCount = 0;
        let tasksErrorCount = 0;
        let errorIds = [];
        data.tasks.forEach((uploadedFile) => {
          let renderItem;
          switch (uploadedFile.task.toLowerCase()) {
            case "error":
              tasksErrorCount++;
              errorIds.push(uploadedFile.id);
              renderItem = this.renderItems.find(
                (i) => i.renderId === uploadedFile.id
              );
              if (renderItem && !renderItem.loaded) {
                renderItem.loaded = true;
                renderItem.error = true;
              }
              renderItem.done = 1;

              break;
            case "prepare":
              break;
            case "start":
              renderItem = this.renderItems.find(
                (i) => i.renderId === uploadedFile.id
              );
              renderItem.done = uploadedFile.done;
              break;
            case "finish":
              tasksDoneCount++;
              renderItem = this.renderItems.find(
                (i) => i.renderId === uploadedFile.id
              );
              if (renderItem && !renderItem.loaded) {
                renderItem.path = uploadedFile.path;
                renderItem.outputName = uploadedFile.fileName;
                renderItem.loaded = true;
                renderItem.fileSize = uploadedFile.size;
                renderItem.done = 1;
              }
              break;
          }
        });
        //Loger block:
        if (tasksDoneCount === 0) {
          //this.percent = 0;
          this.message = "Rendering... " + this.percentNew + "%";
        } else {
          if (tasksDoneCount !== tasksAllCount) {
            //this.percent = Math.floor((tasksDoneCount / tasksAllCount) * 100);
            let progressMsg = "Rendering... " + this.percentNew + "%";

            /*             if (tasksErrorCount != 0) {
              progressMsg += ". Errors: " + tasksErrorCount;
            } */
            this.message = progressMsg;
          } else {
            //this.percent = 100;
            let progressMsg = "Uploading..." + this.percentNew + "%";
            /*             if (tasksErrorCount != 0) {
              progressMsg += ". Errors: " + tasksErrorCount;
            } */
            this.message = progressMsg;
          }
        }
        if (tasksErrorCount === tasksAllCount) {
          //TODO test yandex metrik
          try {
            if (this.$metrika) {
              this.$metrika.reachGoal("render_error", {
                "Ошибка при рендере видео": {
                  CID: 1,
                  type: "successCheckMultiStatus_allTasksError",
                  renderIds: errorIds,
                },
              });
            }
          } catch (e) {
            console.error(e);
          }
          this.message = "Server error!";
          this.stopUpdating();
        }
      }
    },

    convertFileSize(fileSize) {
      const BYTES_TO_KBYTES = 1024;
      const KBYTES_TO_MBYTES = 1024;

      if (fileSize < BYTES_TO_KBYTES) {
        return "<1Kb";
      }

      const fileSizeKB = fileSize / BYTES_TO_KBYTES;

      if (fileSizeKB < 100) {
        return `${Math.ceil(fileSizeKB)}Kb`;
      }

      const fileSizeMb = fileSizeKB / KBYTES_TO_MBYTES;

      if (fileSizeMb < 1) {
        return `${Math.round(fileSizeMb * 100) / 100}Mb`;
      }

      if (fileSizeMb < 10) {
        return `${Math.round(fileSizeMb * 10) / 10}Mb`;
      }

      if (fileSizeMb < 100) {
        return `${Math.round(fileSizeMb)}Mb`;
      }

      return `${Math.round(fileSizeMb)}Mb`;
    },
    //------------------------------------ DOWNLOADING

    downloadResult() {
      let downloadingItems = this.renderItems.filter(
        (i) => i.checked && i.loaded && !i.error
      );
      if (downloadingItems.length > 10) {
        this.downloadArchive(downloadingItems.map((i) => i.renderId));
      } else {
        downloadingItems.forEach((item) => {
          this.downloadFile(item.path, item.outputName);
        });
      }
    },
    downloadArchive(renderIds) {
      this.showLoader = true
      this.axios
        .post(
          "/utils/getArchive",
          {
            renderIds: renderIds,
            sessionId: this.$store.state.userInfo.sessionId,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.downloadFile(response.data.archive);
        })
        .catch((error) => {
          this.message = "Server error!";
          console.error(error);
        })
        .finally(() => {
          this.showLoader = false
        })
    },
    uploadToCloudStorage() {
      this.copyingInfo.isCopyingNow = true;
      this.copyingInfo.text = "Wait...";
      const uploadingItems = this.renderItems
        .filter((i) => i.checked && i.loaded && !i.error)
        .map((i) => i.renderId);
      this.axios
        .post(
          "/utils/shareFiles",
          {
            renderIds: uploadingItems,
            sessionId: this.$store.state.userInfo.sessionId,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          const sharedURL = `${this.$baseURL}/#/shared/${response.data.hash}`;
          console.log(sharedURL);
          navigator.clipboard
            .writeText(sharedURL)
            .then(() => {
              this.copyingInfo.text = "Link copied: ";
              this.copyingInfo.link = sharedURL;
              console.log("Successfully copied");

              try {
                if (this.$metrika) {
                  this.$metrika.reachGoal("shared", {
                    "Кол-во shared файлов ": uploadingItems.length,
                  });
                }
              } catch (e) {
                console.error(e);
              }
            })
            .catch((err) => {
              this.copyingInfo.text = "Uncopied!";
              console.log("Something went wrong", err);
            });
        })
        .catch((error) => {
          this.copyingInfo.isCopyingNow = true;
          this.copyingInfo.text = "Uncopied!";
          this.message = "Server error!";
          console.error(error);
        })
        .finally(() => {
          setTimeout(() => {
            this.copyingInfo.isCopyingNow = false;
            this.copyingInfo.link = null;
          }, 5000);
        });
    },
    downloadFile(path, fileName?) {
      if (path === "") {
        return;
      }
      let downloadHref = this.$baseURL + path;
      let link = document.createElement("a");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link); // Firefox requires the link to be in the body
      link.download = fileName ? fileName : path.split("/").pop();
      link.href = downloadHref;
      link.click();
      document.body.removeChild(link); // remove the link when done
    },
    downloadFileUsingBlob(path, fileName?) {
      if (path === "") {
        return;
      }
      let downloadHref = this.$baseURL + path;
      fetch(downloadHref, {
        /*         headers: {
          "Content-Type": "video/mp4"
        }, */
        mode: "no-cors",
      })
        .then((resp) => resp.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = fileName ? fileName : path.split("/").pop();
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(() => alert("Error file downloading!"));
    },
  },
});
